export default {
  // BaseUrl : 'http://localhost:5000',
  BaseUrl  : 'https://my-first-blog-shubh.herokuapp.com'
};

// http://192.168.50.177/tt/